import React from "react";
import { Route, Switch } from "react-router-dom";
import { Crumb } from "@repoflow/components/breadcrumb";
import * as Section from "@repoflow/components/section";
import SitePublicSchema from "@common/schema/site/public";
import * as ListRoute from "./list";
import * as TemplateRoute from "./template";

// THE BLOG'S TEMPLATES: the three the site renders its blog through, listed,
// and each one's editor. Beneath the blog rather than among the sections
// because that is what they are — see @common/schema/site/blog.
//
// The SITE's schema, not the post's the blog provider carries: a template is a
// field of the site row, written through /Public/Site/Update and edited as a
// /Site/Blog/Template, and both of those live on the site's public schema.
// The Authors screen re-provides the same way, for the same reason.
const LocalProvider = ({ match: { params }, children: Children }) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/template`;
  const basepath = `${parentBasepath}/template`;

  return (
    <Section.Provider
      schema={SitePublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

// `:kind` is closed over the three names: anything else falls through to the
// list rather than opening an editor for a template that cannot exist.
const KIND = ":kind(post|list|collection)";

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/${KIND}`} component={TemplateRoute.Content} />
          <Route path={`${basepath}`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <Crumb to={base} label="Templates" />
          <Switch>
            <Route path={`${basepath}/${KIND}`} component={TemplateRoute.Indice} />
            <Route path={`${basepath}`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => null;
